import React from 'react';
import { useSelector } from 'react-redux';
import { Card, CardBody, Row, Col } from 'reactstrap';
import Skeleton from 'react-loading-skeleton';
import Loader from '../../../components/common/Loader';

//User Images
import avatar2 from "../../../assets/images/users/avatar-2.jpg";
import avatar3 from "../../../assets/images/users/avatar-3.jpg";

const ProfileCard = ({
    smallImage,
    gender,
    ProfileType,
    lastActivity,
    clientDeviceId,
    osName,
    deviceModel,
    profileComment
}) => {
    const demographicLoading = useSelector(state => state.demographic.loading);

    return (
        <Card
            className="team-box"
            style={{
                maxHeight: "418px",
                minHeight: "418px",
                boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)",
                borderRadius: "10px",
            }}
        >
            <div className="team-cover">
                <img src={smallImage} alt="" className="img-fluid" />
            </div>
            <CardBody className="p-4">
                <Row className="align-items-center team-row">
                    <Col lg={4} md={4} xs={12} className="col">
                        <Row className="team-profile-img">
                            <Col lg={12} className="p-0">
                                <div className="d-flex justify-content-between rounded-circle">
                                    <img
                                        src={gender === 'MALE' ? avatar3 : avatar2}
                                        alt=""
                                        className="avatar-lg img-fluid img-thumbnail rounded-circle"
                                    />
                                    <div className="d-flex flex-column  justify-content-center">
                                        <h5 className="fs-13 mb-1 text-white text-end">
                                            {clientDeviceId ? clientDeviceId : <Skeleton />}
                                        </h5>
                                        <p className="fs-17 mb-0 text-white text-end">
                                            {demographicLoading ?  
                                              (
                                               <> <Skeleton /> {" "} <Skeleton /> </>
                                            ) : (
                                                <>{osName} {" "} {deviceModel}</>
                                            ) 
                                          
                                        }

                                        </p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={4} md={8} xs={12} className="col">
                        <Row
                            className="text-muted text-center profile-text"
                            style={{ marginTop: "40px" }}
                        >
                            <Col
                                xs={6}
                                className="border-end border-end-dashed"
                            >
                                <h5 className="mb-1">Last Activity</h5>
                                <p className="text-muted mb-0">
                                    {demographicLoading ?  <Skeleton /> : lastActivity }
                                </p>
                            </Col>
                            <Col xs={6}>
                                <h5 className="mb-1">Profile Type</h5>
                                <p className="text-muted mb-0">
                                    {demographicLoading ?  <Skeleton /> : ProfileType}
                                </p>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </CardBody>

            <Card
                id="profileAnalyse"
                style={{ marginBottom: "45px", overflow: "auto" }}
                className="ribbon-box border-0 shadow-none mb-lg-0"
            >
                <CardBody className="text-muted">
                    <span className="ribbon ribbon-secondary round-shape">
                        <span>Veloxity AI - Profile Analysis</span>
                    </span>

                    <p style={{ marginTop: "35px" }}>
                        {profileComment ? profileComment : <Skeleton count={5.83} />}
                    </p>
                </CardBody>
            </Card>
        </Card>
    );
}

export default ProfileCard;
